module.exports = __webpack_public_path__ + "img/zulong.d03a2278.jpg";